import ajax from '../ajax'

function getList(options: { recent?: boolean } = {}): TaskApiTypes.getList {
  return ajax.get('task', {
    params: {
      recent: options.recent === false ? 'false' : undefined,
    },
  })
}

function getGrouped(options: { recent?: boolean } = {}): TaskApiTypes.getGrouped {
  return ajax.get('task/grouped', {
    params: {
      recent: options.recent === false ? 'false' : undefined,
    },
  })
}

function getByCategory(
  categoryKey: string,
  options: { recent?: boolean } = {},
): TaskApiTypes.getList {
  return ajax.get(`task/category/${categoryKey}`, {
    params: {
      recent: options.recent === false ? 'false' : undefined,
    },
  })
}

function create(name: string, category: string): TaskApiTypes.create {
  return ajax.post('task/create', {
    name,
    category,
  })
}

function deleteOne(key: string): TaskApiTypes.deleteOne {
  return ajax.delete(`task/${key}`)
}

function updateBaseInfo(
  key: string,
  name: string,
  category: string,
): TaskApiTypes.updateBaseInfo {
  return ajax.put(`task/${key}`, {
    name,
    category,
  })
}

function getTaskInfo(key: string): TaskApiTypes.getTaskInfo {
  return ajax.get(`task/${key}`)
}

function getTaskMoreInfo(
  key: string,
  password?: string,
  mode?: 'submit' | 'config',
): TaskApiTypes.getTaskMoreInfo {
  const params: Record<string, string> = {}
  if (password) {
    params.password = password
  }
  if (mode) {
    params.mode = mode
  }
  return ajax.get(`task_info/${key}`, { params })
}

function updateTaskMoreInfo(
  key: string,
  options: TaskApiTypes.TaskInfo,
): TaskApiTypes.updateTaskMoreInfo {
  return ajax.put(`task_info/${key}`, options)
}

function getUsefulTemplate(key: string): TaskApiTypes.getUsefulTemplate {
  return ajax.get(`/task_info/template/${key}`)
}

function delTipImage(key: string, uid: number, name: string) {
  return ajax.delete(`/task_info/tip/image/${key}`, {
    params: {
      uid,
      name,
    },
  })
}

export default {
  getList,
  getGrouped,
  getByCategory,
  create,
  deleteOne,
  updateBaseInfo,
  getTaskInfo,
  getTaskMoreInfo,
  updateTaskMoreInfo,
  getUsefulTemplate,
  delTipImage,
}
